// src/pages/MachineWriteup.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import '../assets/styles/MachineWriteup.css';
import rehypeRaw from 'rehype-raw';

const MachineWriteup = () => {
  const { machineId } = useParams(); // e.g. "SakuraRoom"
  const [md, setMd] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const url = 
      `https://raw.githubusercontent.com/B0bTheSkull/CyberSecWriteUps/main/THM/${machineId}/README.md`;
    console.log('Fetching write-up from', url);
    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error(`Couldn’t load ${url}: ${res.status}`);
        return res.text();
      })
      .then(text => setMd(text))
      .catch(err => setError(err.message));
  }, [machineId]);

  if (error) return <p className="error">Error: {error}</p>;
  if (!md)    return <p>Loading write-up…</p>;

  return (
    <div className="machine-writeup">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          img: ({src, alt, ...props}) => {
            // Use only the filename from any path
            const filename = src.split('/').pop();
            const imgSrc = src.startsWith('http')
              ? src
              : `https://raw.githubusercontent.com/B0bTheSkull/CyberSecWriteUps/main/THM/${machineId}/photos/${filename}`;
            console.log('Rendering image:', imgSrc);
            return <img src={imgSrc} alt={alt} {...props} />;
          }
        }}
      >
        {md}
      </ReactMarkdown>
    </div>
  );
};

export default MachineWriteup;